import { ROUTE_NAMES } from '@/lib/enums';
import { routes as clientsRoutes } from './clients.routes';
import { routes as companiesRoutes } from './companies.routes';
import { routes as profilesRoutes } from './profiles.routes';
import { routes as reviewRoutes } from './review.routes';
import { routes as reviewsRoutes } from './reviews.routes';
import { routes as schedulesRoutes } from './schedules.routes';
import { routes as fetchResponseProfiles } from './fetch-response-profiles.routes';
import { routes as companyRoutes } from './company.routes';
import { routes as aggregationsRoutes } from './aggregations.routes';
import { routes as sectorsRoutes } from './sectors.routes';
import { routes as placeDetailsRoutes } from './place-details.routes';
import { routes as sitesRoutes } from './sites.routes';
import { routes as serviceBusRoutes } from './service-bus.routes';
import { routes as auditRoutes } from './audit.routes';
import { ROLE_USER } from '@/util/roles';

export const routes = [
	{
		path: '',
		name: ROUTE_NAMES.DEPOT.OVERVIEW,
		component: () => {
			return import('@/views/depot/Overview.vue');
		},
		meta: {
			requireAuth: true,
			title: 'Depot - Overview',
			breadcrumb: 'Dashboard',
			// Deliberately below the /depot baseline: the dashboard is the one
			// depot page Depot.User may see. Vue Router merges meta with the
			// deepest matched record winning, so this lowers the bar for this
			// route only and leaves the baseline denying everything else.
			minRole: ROLE_USER,
		},
	},
	...clientsRoutes,
	...companyRoutes,
	...companiesRoutes,
	...sectorsRoutes,
	...profilesRoutes,
	...reviewRoutes,
	...reviewsRoutes,
	...schedulesRoutes,
	...fetchResponseProfiles,
	...aggregationsRoutes,
	...placeDetailsRoutes,
	...sitesRoutes,
	...serviceBusRoutes,
	...auditRoutes,
];
